import "./App.css";
import { Home, InternalServerError, IntlProvider, Transition } from "./Components";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "@progress/kendo-theme-default/dist/all.css";
import Administration from "./Modules/Administrations";
import { MsalProvider, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { getAuthProvider } from "./Auth/authProvider";
import { EventType } from "@azure/msal-browser";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { IMPERSONATION_KEY, UserContext, useUser } from "./Context/UserContext/UserContext";
import { MlsModules } from "./Modules/MLS/MlsModules";
import { UserList } from './Modules/MLS/Feature/Users/UserList';
import { Customer } from "./Modules/Administrations/Features/Customer";
import { Layout, NoMatch404 } from "./Components/Layout";
import { getAppConfiguration } from "./Config";
import { DocumentMls } from "./Modules/MLS/Feature/Documents/DocumentMls";
import { Provider, useDispatch, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/Store";
import { SnackbarProvider, useSnackbar } from "notistack";
import React, { useContext, useEffect, useState } from "react";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { GroupDocument } from "./Modules/MLS/Feature/Group/GroupDocument";
import CreateUser from "./Modules/MLS/Feature/Users/CreateUser";
import { UploadDocument } from "./Modules/MLS/Feature/Documents/UploadDocument";
import { ProcessTemplate } from "./Modules/MLS/Feature/Process/ProcessTemplate";
import { DocumentGroup } from "./Modules/MLS/Feature/DocumentGroup/DocumentGroup/DocumentGroup";
import AdministrationTabs from "./Modules/MLS/Feature/DocumentGroup/DocumentGroup/AdministrationTabs";
import UserSevicesApi from "./Redux/Actions/UserAction";
import { CircularProgress } from "@mui/material";
import { ArchiveDocumentMls } from "./Modules/MLS/Feature/ArchiveDocument/ArchiveDocumentMls";
import { ArchiveUploadDocument } from "./Modules/MLS/Feature/ArchiveDocument/ArchiveUploadDocument";
import { UploadMultipleDocument } from "./Modules/MLS/Feature/Documents/UploadMultipleDocument";
import { ImpersonationBar } from "./Components/ImpersonationBar/ImpersonationBar";
const hash = window.location.hash;
const forgotPasswordKey = "userForgotPassword";
const cancelledForgotPassword = hash.indexOf("AADB2C90091") >= 0;
const containsIdTokenHint = hash.indexOf("id_token_hint=") >= 0;
const containsIdToken = hash.indexOf("id_token=") >= 0;
let idTokenHint = undefined as any;
if (containsIdTokenHint) {
  idTokenHint = hash
    .replace("#", "")
    .split("&")
    .find((seg) => seg.indexOf("id_token_hint=") >= 0);
}
const forgotPassword =
  !containsIdToken &&
  !cancelledForgotPassword &&
  (localStorage.getItem(forgotPasswordKey) === "1" ||
    hash.indexOf("AADB2C90118") >= 0);
const AppRouter = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { currentUser } = useSelector((state: any) => ({
    currentUser: state.UserReducer.currentUser,
  }));
  const appConfig = getAppConfiguration();
  const dispatch: any = useDispatch();
  const [expireToken, setExpireToken] = useState<string>('');
  const [loaing, setLoading] = useState(false)
  const current = instance.getActiveAccount();
  const { enqueueSnackbar } = useSnackbar();
  const { impersonateUser, userImpersonation } = useContext(UserContext);
  const parseJwt = (teken: any) => {
    try {
      return JSON.parse(atob(teken.split('.')[1]));
    } catch (e) {
      return null;
    }
  };
  useEffect(() => {
    //loginHandle();
    setLoading(true)
    const accessTokenRequest = {
      scopes: appConfig.scopes,
      account: accounts[0],
    };
    dispatch(UserSevicesApi.GetToken(instance, accessTokenRequest));
    const tokenAccess = async () => {
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse) => {
        let accessToken = accessTokenResponse.accessToken;
        setExpireToken(accessToken);
        // let user = {
        //   firstName: current?.idTokenClaims?.given_name,
        //   lastName: current?.idTokenClaims?.family_name,
        //   email: current?.idTokenClaims?.email,
        //   b2CAccountId: current?.localAccountId
        // }
        // setLoading(true)
        // dispatch(UserSevicesApi.usersCallApiToken(user, accessToken, instance, enqueueSnackbar));
        // dispatch(UserSevicesApi.UserListData(currentUser?.customerId, accessToken, enqueueSnackbar));
        // setTimeout(() => {
        //   if (currentUser?.firstName) {
        //     setLoading(false);
        //   }
        // }, 3000);
      }).catch((error) => { console.log(error, "===>get token error home") })
      setLoading(false)
    }
    tokenAccess();
    Token();
  }, [instance, accounts]);

useEffect(()=>{
  if(expireToken){
    handleUser(expireToken)
  }
},[userImpersonation,expireToken])
  const handleUser = async (accessToken: any) => {
    setLoading(true)
    if (userImpersonation) {
      let data = JSON.parse(userImpersonation)
      let user = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        b2CAccountId: data?.b2CAccountId
      }
      await dispatch(UserSevicesApi.usersCallApiToken(user, accessToken, instance, enqueueSnackbar));
      // await dispatch(UserSevicesApi.UserListData(data?.customerId, accessToken, enqueueSnackbar));
    } else {
      let user = {
        firstName: current?.idTokenClaims?.given_name,
        lastName: current?.idTokenClaims?.family_name,
        email: current?.idTokenClaims?.email,
        b2CAccountId: current?.localAccountId
      }
      await dispatch(UserSevicesApi.usersCallApiToken(user, accessToken, instance, enqueueSnackbar));
      // await dispatch(UserSevicesApi.UserListData(currentUser?.customerId, accessToken, enqueueSnackbar));
    }
    // let user = {
    //   firstName: current?.idTokenClaims?.given_name,
    //   lastName: current?.idTokenClaims?.family_name,
    //   email: current?.idTokenClaims?.email,
    //   b2CAccountId: current?.localAccountId
    // }
    setLoading(false);
  }

  // useEffect(() => {
  //   if (currentUser?.customerId && expireToken != "") {
  //     dispatch(UserSevicesApi.UserListData(currentUser?.customerId, expireToken, enqueueSnackbar))
  //   }

  // }, [currentUser, expireToken])

  const Token = () => {
    if (expireToken) {
      const decodedJwt = parseJwt(expireToken);
      if (decodedJwt.exp * 1000 < Date.now()) {
        instance.logoutRedirect();
        localStorage.clear();
      }
    }
  }
  useEffect(() => {
    if (!containsIdTokenHint) {
      if (!isAuthenticated) {
        loginHandle();
      }
    }
  }, []);
  // const login = localStorage.getItem("login");
  // useEffect(() => {
  //   if (login == "false") {
  //     localStorage.clear();
  //     instance.logoutRedirect();
  //     instance.loginPopup();
  //   }
  // }, []);
  const loginHandle = async () => {
    await instance.handleRedirectPromise();
    if (accounts.length === 0) {
      await instance.loginRedirect({
        scopes: getAppConfiguration().scopes,
      });
    }
  };

  return (
    <div>
      <Transition isLoading={loaing}>
        <Router>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              {isAuthenticated && (
                <>
                  <Route path="/home" element={<Home />} />
                  <Route path="/ms" element={<MlsModules />}>
                    <Route path="process" element={<ProcessTemplate />} />
                    <Route
                      path="document"
                      element={<DocumentMls action={false} />}
                    >
                      <Route
                        path="upload-several-document/:id"
                        element={<UploadMultipleDocument />}
                      />
                      <Route                        path="upload-document/:id"
                        element={<UploadDocument />}
                      />
                    </Route>
                    <Route
                      path="administrations"
                      element={<AdministrationTabs />}
                    >
                      <Route path="user" element={<UserList />} />
                      <Route path="folder" element={<DocumentGroup />} />
                      <Route path="documents" element={<DocumentMls action={true} />}>
                        <Route
                          path="upload-several-document/:id"
                          element={<UploadMultipleDocument />}
                        />
                        <Route
                          path="upload-document/:id"
                          element={<UploadDocument />}
                        />
                      </Route>
                      <Route path="archive" element={<ArchiveDocumentMls action={true} />}>

                        <Route
                          path="upload-document/:id"
                          element={<ArchiveUploadDocument />}
                        />
                      </Route>
                      <Route path="permission-group" element={<GroupDocument />} />
                      <Route path="create-users" element={<CreateUser />} />
                      <Route
                        path="upload-several-document/:id"
                        element={<UploadMultipleDocument />}
                      />
                      <Route
                        path="upload-document/:id"
                        element={<UploadDocument />}
                      />
                    </Route>
                    <Route path="users" element={<UserList />}>
                      <Route path=":create-user" element={<CreateUser />} />
                    </Route>
                    <Route path="user-group" element={<GroupDocument />} />
                  </Route>
                  {currentUser?.role == "Admin" && (
                    <>
                      <Route
                        path="/administration/:name/*"
                        element={<Administration />}
                      />
                      <Route path="/customer" element={<Customer />} />
                      <Route path="*" element={<NoMatch404 />} />
                    </>
                  )}
                </>
              )}
            </Route>
          </Routes>     
        </Router>
        {userImpersonation != undefined&& (
          <ImpersonationBar />
        )}
      </Transition>

    </div>
  );
};
const AppContainer = () => {
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRouter />
        </PersistGate>
      </Provider>
    </>
  );
};
const cookieCleaner = () => {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name +
      "=;" +
      "expires=Thu, 01-Jan-1970 00:00:01 GMT;" +
      "path=" +
      "/;" +
      "domain=" +
      window.location.host +
      ";" +
      "secure=;";
  }
};
const authProvider = getAuthProvider();
if (
  (containsIdTokenHint || forgotPassword || cancelledForgotPassword) &&
  !containsIdToken
) {
  sessionStorage.clear();
  cookieCleaner();
}
if (containsIdTokenHint && idTokenHint) {
  authProvider.loginRedirect({
    scopes: getAppConfiguration().scopes,
    extraQueryParameters: {
      id_token_hint: idTokenHint.split("=")[1],
      login_hint: "",
    },
  });
}
authProvider.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    authProvider.setActiveAccount(event.payload as any);
  }
});
function App() {
  const { Provider } = UserContext;
  let authProvider = getAuthProvider();
  const user = useUser();
  const notistackRef = React.createRef() as any;
  const onClickDismiss = (key: string | number | undefined) => () => {
    notistackRef.current.closeSnackbar(key);
  };
  return (
    <SnackbarProvider
      ref={notistackRef}
      action={(key) => (
        <IconButton onClick={onClickDismiss(key)}>
          <Close />
        </IconButton>
      )}
    >
      <MsalProvider instance={authProvider}>
        <Provider value={user}>
          <IntlProvider>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <AppContainer />
            </MuiPickersUtilsProvider>
          </IntlProvider>
        </Provider>
      </MsalProvider>
    </SnackbarProvider>
  );
}
export default App;
